import React, { useState } from 'react'
import { Button, Collapse, Form } from 'antd'
import { chooseEmailModalFxn, DisplayDate } from '../../../../components/_utils/appUtils'
import { RowTable } from '../../../article/articleView/RowTable'
import CommentsToAbstractDrawer from '../abstractPages/CommentsToAuthorAbstracts'
import { ResendAbstractComments } from '../actions'
import { useDispatch } from 'react-redux'

const { Panel } = Collapse

const CommentsToAuthor = (props) => {
  let { abstract, form ,showCommentsDrawer} = props
  let { sendToAuthorDate, statusType, reminderDateCommentsToAuthor } = abstract


  let dispatch = useDispatch()

  let headerTitle = `Comments to Author ${sendToAuthorDate ? `(${DisplayDate(sendToAuthorDate)})` : ''}`
  const handleResend = (abstract) => {
    chooseEmailModalFxn({
      title: 'Send Comments to Author',
      callback: async (email) => {
        let valData = {
          abstractId: abstract._id,
          id: abstract._id,
          fromEmail: email,
          flag: 'Abstract'
        };

        // 1. Dispatch the action
        let resp = await dispatch(ResendAbstractComments(valData));

        // 2. Refresh logic
        if (resp && resp.success) {
          // Dispatch the loading state to Redux if needed
          dispatch({ type: 'START_LOAD_ABSTRACT' });

          // 3. Call the parent's reload function
          if (props.callback) {
            props.callback();
          }
        }
      }
    });
  };
  // let getExtraButton = () => (
  //   <div onClick={(e) => e.stopPropagation()}>
  //     <Button type="button" size="small" onClick={(e) => handleResendComments(e)}>
  //       Resend Comments
  //     </Button>
  //     {' '}
  //     <Button
  //       type="primary"
  //       size="small"
  //       type="button"
  //       onClick={() => showCommentsDrawer()}
  //     >
  //       Add
  //     </Button>
  //   </div>
  // );
  let getExtraButton = () => (
    <div onClick={(e) => e.stopPropagation()}>
      <Button
        type="button"
        size="small"
        onClick={(e) => handleResend(abstract)}
        style={{
          backgroundColor: 'black',
          borderColor: 'black',
          color: 'white',
          marginRight: '8px'
        }}
      >
        Resend Comments
      </Button>      {' '}
      <Button
        type="primary"
        size="small"
        type="button"
        style={{ backgroundColor: 'black', borderColor: 'black', color: 'white' }}
        onClick={() => showCommentsDrawer()}
      >
        {sendToAuthorDate ? 'Edit' : 'Add'}
      </Button>
    </div>
  );
  return (
    <div>
      <Collapse expandIconPosition={'right'} defaultActiveKey={['1']}>
        <Panel header={headerTitle} key='1' extra={getExtraButton()}>
          <div className={'tableBox striped'}>
            <RowTable title={'Date'} value={sendToAuthorDate ? DisplayDate(sendToAuthorDate) : null} />
            <RowTable title={'Status Type'} value={statusType || null} />
            <RowTable title={'Reminder Date'} value={reminderDateCommentsToAuthor ? DisplayDate(reminderDateCommentsToAuthor) : null} />
          </div>
        </Panel>
      </Collapse>

      {/*{visibleDrawer ? (*/}
      {/*  <CommentsToAbstractDrawer*/}
      {/*    visible={visibleDrawer}*/}
      {/*    abstractId={abstract._id}*/}
      {/*    abstract={abstract}*/}
      {/*    onClose={() => setVisibleDrawer(false)}*/}
      {/*  />*/}
      {/*) : null}*/}
    </div>
  )
}

export default Form.create()(CommentsToAuthor)
